import React from "react";
import { ResponsiveType } from "../../../interface/redux/config";
import { useLanguage } from "../../../hooks/useLanguage";
import styles from "./Ci.module.css";

type Props = { Responsive: ResponsiveType };
const CiSection3 = (_: Props) => {
  const { isKr } = useLanguage();
  return (
    <section className={styles.section}>
      <p className={styles.eyebrow}>LOGO USAGE</p>
      <h2 className={styles.title}>{isKr ? "배경에 맞게, 형태는 그대로" : "Adapt to the background. Preserve the form."}</h2>
      <p className={styles.copy}>{isKr ? "밝은 배경에는 컬러 기본형을, 어두운 배경에는 흰색 반전형을 사용합니다. 심볼과 워드마크의 비율과 간격은 제공된 원본을 그대로 유지합니다." : "Use the primary colour logo on light backgrounds and the white version on dark backgrounds. Keep the proportions and spacing of the symbol and wordmark as supplied."}</p>
      <div className={styles.variants}>
        <figure><div className={`${styles.logoPanel} ${styles.light}`}><img src="/assets/brand/huconn-primary.svg" alt={isKr ? "밝은 배경의 컬러 기본형" : "Primary colour logo on a light background"} /></div><figcaption className={styles.caption}>{isKr ? "기본형 · 밝은 배경" : "Primary logo · light background"}</figcaption></figure>
        <figure><div className={`${styles.logoPanel} ${styles.dark}`}><img src="/assets/brand/huconn-white.svg" alt={isKr ? "어두운 배경의 흰색 반전형" : "White logo on a dark background"} /></div><figcaption className={styles.caption}>{isKr ? "흰색 반전형 · 어두운 배경" : "White logo · dark background"}</figcaption></figure>
      </div>
      <ul className={styles.rules}>
        <li>{isKr ? "가로세로 비율을 유지하고, 로고 주변에는 심볼 너비의 1/4 이상 여백을 확보합니다." : "Keep the original aspect ratio and leave clear space of at least one quarter of the symbol’s width around the logo."}</li>
        <li>{isKr ? "작은 아이콘에는 심볼 단독형을 사용합니다. 임의로 색을 바꾸거나 그림자·그라데이션을 추가하지 않습니다." : "Use the symbol on its own for small icons. Do not recolour the logo or add shadows or gradients."}</li>
        <li>{isKr ? "확대가 필요한 작업에는 SVG를, 이미지 파일이 필요한 곳에는 PNG를 사용합니다." : "Use SVG when scaling is needed, and PNG where a raster image is required."}</li>
      </ul>
      <div className={styles.downloads}>
        <a href="/assets/brand/huconn-primary.svg" download="HUCONN.svg">{isKr ? "기본 로고 SVG" : "Primary logo SVG"}<span aria-hidden="true">↓</span></a>
        <a href="/file/logo.zip" download="HUCONN-PNG-Pack.zip">{isKr ? "PNG 로고 패키지" : "PNG logo package"}<span aria-hidden="true">↓</span></a>
      </div>
    </section>
  );
};
export default CiSection3;
